import { render, staticRenderFns } from "./InstitucionesForm.vue?vue&type=template&id=77033f65&"
import script from "./InstitucionesForm.vue?vue&type=script&lang=js&"
export * from "./InstitucionesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports